import React, { useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ThemePicker from './components/ThemePicker';
import Home from './pages/Home';
import Features from './pages/Features';
import ReadAlong from './pages/ReadAlong';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Downloads from './pages/Downloads';
import ShelfPulse from './pages/ShelfPulse';
import ShelfPulseTerms from './pages/ShelfPulseTerms';
import ShelfPulsePrivacy from './pages/ShelfPulsePrivacy';
import ComingSoon from './pages/ComingSoon';
import Beta from './pages/Beta';
import { SITE_LIVE, ALWAYS_ACCESSIBLE } from './config';
import './styles/App.css';

function App() {
  const location = useLocation();
  const isShelfPulse = location.pathname.startsWith('/shelfpulse');
  const isReleases = location.pathname === '/releases';
  const [themePickerOpen, setThemePickerOpen] = useState(false);

  // Check if current path is always accessible
  const isAccessible = ALWAYS_ACCESSIBLE.some(path =>
    location.pathname === path || location.pathname.startsWith(path + '/')
  );

  // If site is not live and path is not accessible, show Coming Soon
  if (!SITE_LIVE && !isAccessible) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/releases" element={<Beta />} />
          <Route path="/beta" element={<Navigate to="/releases" replace />} />
          <Route path="/terms/*" element={<Terms />} />
          <Route path="/privacy/*" element={<Privacy />} />
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </>
    );
  }

  // ShelfPulse has its own nav/footer, so render it standalone
  if (isShelfPulse) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/shelfpulse" element={<ShelfPulse />} />
          <Route path="/shelfpulse/terms/*" element={<ShelfPulseTerms />} />
          <Route path="/shelfpulse/privacy/*" element={<ShelfPulsePrivacy />} />
        </Routes>
      </>
    );
  }

  // Releases page (with nav, no footer)
  if (isReleases) {
    return (
      <div className="app">
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/releases" element={<Beta />} />
          </Routes>
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <ScrollToTop />
      <Navbar onOpenThemePicker={() => setThemePickerOpen(true)} />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/read-along" element={<ReadAlong />} />
          <Route path="/readalong" element={<Navigate to="/read-along" replace />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/terms/*" element={<Terms />} />
          <Route path="/privacy/*" element={<Privacy />} />
          <Route path="/releases" element={<Beta />} />
          <Route path="/beta" element={<Navigate to="/releases" replace />} />
        </Routes>
      </main>
      <Footer />
      <ThemePicker isOpen={themePickerOpen} setIsOpen={setThemePickerOpen} />
    </div>
  );
}

export default App;
